// ⚠️ FICHIER GÉNÉRÉ AUTOMATIQUEMENT — ne pas éditer à la main.
// Régénérer : node scripts/build-visite-iles.mjs  (scanne public/media/audio/)

export const iles = [
  {
    "id": "ile-01",
    "number": 1,
    "title": "Île 1",
    "audios": [
      {
        "label": "Vierge noire",
        "sources": {
          "en": "/media/audio/ILE_01/Ile_01_Vierge_noire_VAn.mp3",
          "gcf": "/media/audio/ILE_01/Ile_01_Vierge_noire_VCr.mp3",
          "es": "/media/audio/ILE_01/Ile_01_Vierge_noire_VEs.mp3",
          "fr": "/media/audio/ILE_01/Ile_01_Vierge_noire_VFr.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-02",
    "number": 2,
    "title": "Île 2",
    "audios": [
      {
        "label": "4Destins",
        "sources": {
          "fr": "/media/audio/ILE_02/Ile_02_4Destins_New_VFr.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-03",
    "number": 3,
    "title": "Île 3",
    "audios": [
      {
        "label": "Conquete",
        "sources": {
          "en": "/media/audio/ILE_03/Ile_03_Conquete_VAn.mp3",
          "gcf": "/media/audio/ILE_03/Ile_03_Conquete_VCr.mp3",
          "es": "/media/audio/ILE_03/Ile_03_Conquete_VEs.mp3",
          "fr": "/media/audio/ILE_03/Ile_03_Conquete_VFr.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-04",
    "number": 4,
    "title": "Île 4",
    "audios": [
      {
        "label": "Amerindiens",
        "sources": {
          "en": "/media/audio/ILE_04/Ile_04_Amerindiens_VAn.mp3",
          "gcf": "/media/audio/ILE_04/Ile_04_Amerindiens_VCr.mp3",
          "es": "/media/audio/ILE_04/Ile_04_Amerindiens_VEs.mp3",
          "fr": "/media/audio/ILE_04/Ile_04_Amerindiens_VFr.mp3"
        }
      },
      {
        "label": "Vitrine 1",
        "sources": {
          "fr": "/media/audio/ILE_04/Ile_04_Vitrine-1_VFr.mp3"
        }
      },
      {
        "label": "Vitrine 2",
        "sources": {
          "fr": "/media/audio/ILE_04/Ile_04_Vitrine-2_VFr.mp3"
        }
      },
      {
        "label": "Vitrine 3",
        "sources": {
          "fr": "/media/audio/ILE_04/Ile_04_Vitrine-3_VFr.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-05",
    "number": 5,
    "title": "Île 5",
    "audios": [
      {
        "label": "Pirates",
        "sources": {
          "all": "/media/audio/ILE_05/Ile_05-Pirates_New.mp3"
        }
      },
      {
        "label": "Vitrine 1",
        "sources": {
          "fr": "/media/audio/ILE_05/Ile_05_Vitrine-1_VFr.mp3"
        }
      },
      {
        "label": "Vitrine 2",
        "sources": {
          "fr": "/media/audio/ILE_05/Ile_05_Vitrine-2_VFr.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-06",
    "number": 6,
    "title": "Île 6",
    "audios": [
      {
        "label": "Panorama",
        "sources": {
          "en": "/media/audio/ILE_06/Ile_06_Panorama_VAn.mp3",
          "gcf": "/media/audio/ILE_06/Ile_06_Panorama_VCr.mp3",
          "es": "/media/audio/ILE_06/Ile_06_Panorama_VEs.mp3",
          "fr": "/media/audio/ILE_06/Ile_06_Panorama_VFr.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-07",
    "number": 7,
    "title": "Île 7",
    "audios": [
      {
        "label": "Controverse",
        "sources": {
          "all": "/media/audio/ILE_07/Ile_07-Controverse_New.mp3"
        }
      },
      {
        "label": "Vitrine",
        "sources": {
          "fr": "/media/audio/ILE_07/Ile_07_Vitrine-VFr.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-08",
    "number": 8,
    "title": "Île 8",
    "audios": [
      {
        "label": "Afrique XVe",
        "sources": {
          "en": "/media/audio/ILE_08/Ile_08_Afrique_XVe_VAn.mp3",
          "gcf": "/media/audio/ILE_08/Ile_08_Afrique_XVe_VCr.mp3",
          "es": "/media/audio/ILE_08/Ile_08_Afrique_XVe_VEs.mp3",
          "fr": "/media/audio/ILE_08/Ile_08_Afrique_XVe_VFr.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-09",
    "number": 9,
    "title": "Île 9",
    "audios": [
      {
        "label": "Ouidah",
        "sources": {
          "all": "/media/audio/ILE_09/Ile_09_Ouidah.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-10",
    "number": 10,
    "title": "Île 10",
    "audios": [
      {
        "label": "Commerce triangulaire",
        "sources": {
          "en": "/media/audio/ILE_10/Ile_10_Commerce_triangulaire_VAn.mp3",
          "gcf": "/media/audio/ILE_10/Ile_10_Commerce_triangulaire_VCr.mp3",
          "es": "/media/audio/ILE_10/Ile_10_Commerce_triangulaire_VEs.mp3",
          "fr": "/media/audio/ILE_10/Ile_10_Commerce_triangulaire_VFr.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-11",
    "number": 11,
    "title": "Île 11",
    "audios": [
      {
        "label": "Flux Esclavage",
        "sources": {
          "en": "/media/audio/ILE_11/Ile_11_Flux_Esclavage_VAn.mp3",
          "gcf": "/media/audio/ILE_11/Ile_11_Flux_Esclavage_VCr.mp3",
          "es": "/media/audio/ILE_11/Ile_11_Flux_Esclavage_VEs.mp3",
          "fr": "/media/audio/ILE_11/Ile_11_Flux_Esclavage_VFr.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-12",
    "number": 12,
    "title": "Île 12",
    "audios": [
      {
        "label": "Traversee",
        "sources": {
          "all": "/media/audio/ILE_12/Ile_12-Traversee_New.mp3"
        }
      },
      {
        "label": "Traversee Enceintes Murs",
        "sources": {
          "all": "/media/audio/ILE_12/Ile_12-Traversee_Enceintes_Murs.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-13",
    "number": 13,
    "title": "Île 13",
    "audios": [
      {
        "label": "Code Noir",
        "sources": {
          "all": "/media/audio/ILE_13/Ile_13_Code-Noir.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-14",
    "number": 14,
    "title": "Île 14",
    "audios": [
      {
        "label": "Repression",
        "sources": {
          "en": "/media/audio/ILE_14/Ile_14_Repression_VAn.mp3",
          "gcf": "/media/audio/ILE_14/Ile_14_Repression_VCr.mp3",
          "es": "/media/audio/ILE_14/Ile_14_Repression_VEs.mp3",
          "fr": "/media/audio/ILE_14/Ile_14_Repression_VFr.mp3"
        }
      },
      {
        "label": "Vitrine",
        "sources": {
          "fr": "/media/audio/ILE_14/Ile_14_Vitrine_VFr.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-15",
    "number": 15,
    "title": "Île 15",
    "audios": [
      {
        "label": "Societe habitation",
        "sources": {
          "en": "/media/audio/ILE_15/Ile_15_societe_habitation_VAn.mp3",
          "gcf": "/media/audio/ILE_15/Ile_15_societe_habitation_VCr.mp3",
          "es": "/media/audio/ILE_15/Ile_15_societe_habitation_VEs.mp3",
          "fr": "/media/audio/ILE_15/Ile_15_societe_habitation_VFr.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-16",
    "number": 16,
    "title": "Île 16",
    "audios": [
      {
        "label": "Case negre",
        "sources": {
          "all": "/media/audio/ILE_16/Ile_16_case_negre.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-17",
    "number": 17,
    "title": "Île 17",
    "audios": [
      {
        "label": "Commentaire",
        "sources": {
          "fr": "/media/audio/ILE_17/Ile_17_VFr.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-18",
    "number": 18,
    "title": "Île 18",
    "audios": [
      {
        "label": "Jardin esclave Vesper I",
        "sources": {
          "en": "/media/audio/ILE_18/Ile_18_jardin_esclave_VAn-Vesper_I.mp3",
          "gcf": "/media/audio/ILE_18/Ile_18_jardin_esclave_VCr-Vesper_I.mp3",
          "es": "/media/audio/ILE_18/Ile_18_jardin_esclave_VEs-Vesper_I.mp3",
          "fr": "/media/audio/ILE_18/Ile_18_jardin_esclave_VFr-Vesper_I.mp3"
        }
      },
      {
        "label": "Vesper II",
        "sources": {
          "all": "/media/audio/ILE_18/Ile_18_Vesper_II.mp3"
        }
      },
      {
        "label": "Vesper III",
        "sources": {
          "all": "/media/audio/ILE_18/Ile_18_Vesper_III.mp3"
        }
      },
      {
        "label": "Vesper IV",
        "sources": {
          "all": "/media/audio/ILE_18/Ile_18_Vesper_IV.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-19",
    "number": 19,
    "title": "Île 19",
    "audios": [
      {
        "label": "Mur",
        "sources": {
          "en": "/media/audio/ILE_19/Ile_19_Mur_VAn.mp3",
          "gcf": "/media/audio/ILE_19/Ile_19_Mur_VCr.mp3",
          "es": "/media/audio/ILE_19/Ile_19_Mur_VEs.mp3",
          "fr": "/media/audio/ILE_19/Ile_19_Mur_VFr.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-20",
    "number": 20,
    "title": "Île 20",
    "audios": [
      {
        "label": "Franc macon",
        "sources": {
          "en": "/media/audio/ILE_20/Ile_20_franc_macon_VAn.mp3",
          "gcf": "/media/audio/ILE_20/Ile_20_franc_macon_VCr.mp3",
          "es": "/media/audio/ILE_20/Ile_20_franc_macon_VEs.mp3",
          "fr": "/media/audio/ILE_20/Ile_20_franc_macon_VFr.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-21",
    "number": 21,
    "title": "Île 21",
    "audios": [
      {
        "label": "Ceremonies",
        "sources": {
          "all": "/media/audio/ILE_21/Ile_21_Ceremonies.mp3"
        }
      },
      {
        "label": "Vitrine",
        "sources": {
          "fr": "/media/audio/ILE_21/Ile_21_Vitrine_VFr.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-22",
    "number": 22,
    "title": "Île 22",
    "audios": [
      {
        "label": "Religion",
        "sources": {
          "en": "/media/audio/ILE_22/Ile_22_Religion_VAn.mp3",
          "gcf": "/media/audio/ILE_22/Ile_22_Religion_VCr.mp3",
          "es": "/media/audio/ILE_22/Ile_22_Religion_VEs.mp3",
          "fr": "/media/audio/ILE_22/Ile_22_Religion_VFr.mp3"
        }
      },
      {
        "label": "Vitrine 1",
        "sources": {
          "fr": "/media/audio/ILE_22/Ile_22_Vitrine-1_VFr.mp3"
        }
      },
      {
        "label": "Vitrine 2",
        "sources": {
          "fr": "/media/audio/ILE_22/Ile_22_Vitrine-2_VFr.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-23",
    "number": 23,
    "title": "Île 23",
    "audios": [
      {
        "label": "Tambours",
        "sources": {
          "en": "/media/audio/ILE_23/Ile_23_Tambours_VAn.mp3",
          "gcf": "/media/audio/ILE_23/Ile_23_Tambours_VCr.mp3",
          "es": "/media/audio/ILE_23/Ile_23_Tambours_VEs.mp3",
          "fr": "/media/audio/ILE_23/Ile_23_Tambours_VFr.mp3"
        }
      },
      {
        "label": "Vitrine",
        "sources": {
          "fr": "/media/audio/ILE_23/Ile_23_Vitrine_VFr.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-24",
    "number": 24,
    "title": "Île 24",
    "audios": [
      {
        "label": "Mascarade Carnaval",
        "sources": {
          "en": "/media/audio/ILE_24/Ile_24-Mascarade_Carnaval_New_VAn.mp3",
          "gcf": "/media/audio/ILE_24/Ile_24-Mascarade_Carnaval_New_VCr.mp3",
          "es": "/media/audio/ILE_24/Ile_24-Mascarade_Carnaval_New_VEs.mp3",
          "fr": "/media/audio/ILE_24/Ile_24-Mascarade_Carnaval_New_VFr.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-25",
    "number": 25,
    "title": "Île 25",
    "audios": [
      {
        "label": "St Domingue",
        "sources": {
          "en": "/media/audio/ILE_25/Ile_25-St_Domingue_New_VAn.mp3",
          "gcf": "/media/audio/ILE_25/Ile_25-St_Domingue_New_VCr.mp3",
          "es": "/media/audio/ILE_25/Ile_25-St_Domingue_New_VEs.mp3",
          "fr": "/media/audio/ILE_25/Ile_25-St_Domingue_New_VFr.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-26",
    "number": 26,
    "title": "Île 26",
    "audios": [
      {
        "label": "Abolition Retablissement",
        "sources": {
          "en": "/media/audio/ILE_26/Ile_26-Abolition_Retablissement_VAn.mp3",
          "gcf": "/media/audio/ILE_26/Ile_26-Abolition_Retablissement_VCr.mp3",
          "es": "/media/audio/ILE_26/Ile_26-Abolition_Retablissement_VEs.mp3",
          "fr": "/media/audio/ILE_26/Ile_26-Abolition_Retablissement_VFr.mp3"
        }
      },
      {
        "label": "OnDemand ShuckOne",
        "sources": {
          "all": "/media/audio/ILE_26/Ile_26_OnDemand_ShuckOne.mp3"
        }
      },
      {
        "label": "Vitrine",
        "sources": {
          "fr": "/media/audio/ILE_26/Ile_26_Vitrine-VFr.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-27",
    "number": 27,
    "title": "Île 27",
    "audios": [
      {
        "label": "Guerre Napoleon",
        "sources": {
          "all": "/media/audio/ILE_27/Ile_27_Guerre_Napoleon.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-28",
    "number": 28,
    "title": "Île 28",
    "audios": [
      {
        "label": "Abolitionnistes",
        "sources": {
          "en": "/media/audio/ILE_28/Ile_28_Abolitionnistes_VAn.mp3",
          "gcf": "/media/audio/ILE_28/Ile_28_Abolitionnistes_VCr.mp3",
          "es": "/media/audio/ILE_28/Ile_28_Abolitionnistes_VEs.mp3",
          "fr": "/media/audio/ILE_28/Ile_28_Abolitionnistes_VFr.mp3"
        }
      },
      {
        "label": "Vitrine 1",
        "sources": {
          "fr": "/media/audio/ILE_28/Ile_28_Vitrine-1_VFr.mp3"
        }
      },
      {
        "label": "Vitrine 2",
        "sources": {
          "fr": "/media/audio/ILE_28/Ile_28_Vitrine-2_VFr.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-29",
    "number": 29,
    "title": "Île 29",
    "audios": [
      {
        "label": "Engages Darboussier",
        "sources": {
          "en": "/media/audio/ILE_29/Ile_29_Engages_Darboussier_VAn.mp3",
          "gcf": "/media/audio/ILE_29/Ile_29_Engages_Darboussier_VCr.mp3",
          "es": "/media/audio/ILE_29/Ile_29_Engages_Darboussier_VEs.mp3",
          "fr": "/media/audio/ILE_29/Ile_29_Engages_Darboussier_VFr.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-30",
    "number": 30,
    "title": "Île 30",
    "audios": [
      {
        "label": "Etats Unis",
        "sources": {
          "en": "/media/audio/ILE_30/Ile_30_Etats_Unis_VAn.mp3",
          "gcf": "/media/audio/ILE_30/Ile_30_Etats_Unis_VCr.mp3",
          "es": "/media/audio/ILE_30/Ile_30_Etats_Unis_VEs.mp3",
          "fr": "/media/audio/ILE_30/Ile_30_Etats_Unis_VFr.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-31",
    "number": 31,
    "title": "Île 31",
    "audios": [
      {
        "label": "Terre Promise",
        "sources": {
          "en": "/media/audio/ILE_31/Ile_31B_Terre_Promise_VAn.mp3",
          "gcf": "/media/audio/ILE_31/Ile_31B_Terre_Promise_VCr.mp3",
          "es": "/media/audio/ILE_31/Ile_31B_Terre_Promise_VEs.mp3",
          "fr": "/media/audio/ILE_31/Ile_31B_Terre_Promise_VFr.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-32",
    "number": 32,
    "title": "Île 32",
    "audios": [
      {
        "label": "Colonisation Decolo",
        "sources": {
          "en": "/media/audio/ILE_32/Ile_32_Colonisation_Decolo_VAn.mp3",
          "gcf": "/media/audio/ILE_32/Ile_32_Colonisation_Decolo_VCr.mp3",
          "es": "/media/audio/ILE_32/Ile_32_Colonisation_Decolo_VEs.mp3",
          "fr": "/media/audio/ILE_32/Ile_32_Colonisation_Decolo_VFr.mp3"
        }
      },
      {
        "label": "Vitrine",
        "sources": {
          "fr": "/media/audio/ILE_32/Ile_32_Vitrine-VFr.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-33",
    "number": 33,
    "title": "Île 33",
    "audios": [
      {
        "label": "MASTER Mutation image Noir",
        "sources": {
          "all": "/media/audio/ILE_33/Ile_33-MASTER-Mutation_image_Noir.mp3"
        }
      },
      {
        "label": "Vitrine",
        "sources": {
          "fr": "/media/audio/ILE_33/Ile_33_Vitrine-VFr.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-34",
    "number": 34,
    "title": "Île 34",
    "audios": [
      {
        "label": "War Bob Marley",
        "sources": {
          "all": "/media/audio/ILE_34/Ile_34_War_Bob_Marley.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-35",
    "number": 35,
    "title": "Île 35",
    "audios": [
      {
        "label": "Alienations contemporaines",
        "sources": {
          "all": "/media/audio/ILE_35/Ile_35_Alienations_contemporaines.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-36",
    "number": 36,
    "title": "Île 36",
    "audios": [
      {
        "label": "Pluralite Guadeloupeenne",
        "sources": {
          "all": "/media/audio/ILE_36/Ile_36_Pluralite_Guadeloupeenne.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-37",
    "number": 37,
    "title": "Île 37",
    "audios": [
      {
        "label": "NegroCaraibes",
        "sources": {
          "all": "/media/audio/ILE_37/Ile-37_NegroCaraibes.mp3"
        }
      }
    ]
  },
  {
    "id": "ile-38",
    "number": 38,
    "title": "Île 38",
    "audios": [
      {
        "label": "A 00",
        "sources": {
          "all": "/media/audio/ILE_38/Ile_38_a_00.mp3"
        }
      }
    ]
  }
];
